import React from 'react';

export interface ProgressBarTooltipProps {
  text?: string;
  style?: React.CSSProperties;
  triangleStyle?: React.CSSProperties;
}

export const ProgressBarTooltip: React.FC<ProgressBarTooltipProps> = ({
  text = '',
  style,
  triangleStyle,
}) => {
  return (
    <div className="oejr-progress-bar-tooltip" style={style}>
      <span>{text}</span>
      <div className="triangle" style={triangleStyle} />
    </div>
  );
};
